// Detailed data for the Keyword Landscape Output page

export interface ProductMetrics {
  id: string;
  position: number;
  isHero: boolean;
  brand: string;
  title: string;
  asin: string;
  imageUrl: string;
  reviews: number;
  rating: number;
  price: number;
  bsr: number;
  estMonthlyUnits: number;
  estMonthlyRevenue: number;
  capturedSearchVol: number;
  revVolRatio: number;
  top15Positions: number;
}

export interface KeywordRanking {
  id: string;
  keyword: string;
  competitors: number;
  exactVol: number;
  // ranks for each product position (1-10), null means "NA"
  ranks: (number | null)[];
  kpg: number;
  search_volume: number;
  ppc_max_bid: number;
  hero_relevance: number;
}

export interface LandscapeOutputData {
  id: string;
  prioritySearchPhrase: string;
  date: string;
  totals: {
    relevantKeywords: number;
    exactVolume: number;
    monthlyUnits: number;
  };
  products: ProductMetrics[];
  keywords: KeywordRanking[];
}

// Mock data for "mattifying lotion" landscape
export const mockLandscapeOutputs: Record<string, LandscapeOutputData> = {
  "1-4-1": {
    id: "1-4-1",
    prioritySearchPhrase: "mattifying lotion",
    date: "Nov 13, 2025",
    totals: {
      relevantKeywords: 2074,
      exactVolume: 789192,
      monthlyUnits: 21543,
    },
    products: [
      {
        id: "p1",
        position: 1,
        isHero: true,
        brand: "Supergoop!",
        title: "Supergoop! Mineral Mattescreen (SPF 40)",
        asin: "B09JVX2NNR",
        imageUrl: "/placeholder.svg",
        reviews: 1373,
        rating: 4.6,
        price: 39.95,
        bsr: 6517,
        estMonthlyUnits: 6580,
        estMonthlyRevenue: 256839,
        capturedSearchVol: 74415,
        revVolRatio: 3.45,
        top15Positions: 327,
      },
      {
        id: "p2",
        position: 2,
        isHero: false,
        brand: "Cetaphil",
        title: "Cetaphil Face Moisturizer",
        asin: "B093W4D1T3",
        imageUrl: "/placeholder.svg",
        reviews: 9610,
        rating: 4.5,
        price: 10.97,
        bsr: 752,
        estMonthlyUnits: 17989,
        estMonthlyRevenue: 190879,
        capturedSearchVol: 178705,
        revVolRatio: 1.07,
        top15Positions: 528,
      },
      {
        id: "p3",
        position: 3,
        isHero: false,
        brand: "La Roche-Posay",
        title: "La Roche-Posay Toleriane",
        asin: "B09N13T8TL",
        imageUrl: "/placeholder.svg",
        reviews: 8099,
        rating: 4.5,
        price: 24.99,
        bsr: 1049,
        estMonthlyUnits: 21543,
        estMonthlyRevenue: 501483,
        capturedSearchVol: 264108,
        revVolRatio: 1.90,
        top15Positions: 512,
      },
      {
        id: "p4",
        position: 4,
        isHero: false,
        brand: "CeraVe",
        title: "CeraVe Ultra-Light Moisturizing",
        asin: "B0C7HMKH3G",
        imageUrl: "/placeholder.svg",
        reviews: 4005,
        rating: 4.7,
        price: 16.18,
        bsr: 1056,
        estMonthlyUnits: 18051,
        estMonthlyRevenue: 283514,
        capturedSearchVol: 228352,
        revVolRatio: 1.24,
        top15Positions: 545,
      },
      {
        id: "p5",
        position: 5,
        isHero: false,
        brand: "Cetaphil",
        title: "Cetaphil DermaCo",
        asin: "B076D1961B",
        imageUrl: "/placeholder.svg",
        reviews: 15675,
        rating: 4.4,
        price: 14.38,
        bsr: 3216,
        estMonthlyUnits: 8690,
        estMonthlyRevenue: 120346,
        capturedSearchVol: 100909,
        revVolRatio: 1.19,
        top15Positions: 371,
      },
      {
        id: "p6",
        position: 6,
        isHero: false,
        brand: "CeraVe",
        title: "CeraVe Oil Control Moisturizer",
        asin: "B0CTTv9126",
        imageUrl: "/placeholder.svg",
        reviews: 1942,
        rating: 4.6,
        price: 16.18,
        bsr: 1881,
        estMonthlyUnits: 10705,
        estMonthlyRevenue: 167109,
        capturedSearchVol: 224266,
        revVolRatio: 0.75,
        top15Positions: 572,
      },
      {
        id: "p7",
        position: 7,
        isHero: false,
        brand: "PanOxyl",
        title: "PanOxyl AM Oil Control",
        asin: "B09583P2PR",
        imageUrl: "/placeholder.svg",
        reviews: 1314,
        rating: 4.4,
        price: 10.42,
        bsr: 5052,
        estMonthlyUnits: 5652,
        estMonthlyRevenue: 55482,
        capturedSearchVol: 67346,
        revVolRatio: 0.82,
        top15Positions: 244,
      },
      {
        id: "p8",
        position: 8,
        isHero: false,
        brand: "COSRX",
        title: "COSRX Oil Free Lotion",
        asin: "B01CLTX14A",
        imageUrl: "/placeholder.svg",
        reviews: 7277,
        rating: 4.6,
        price: 18.99,
        bsr: 5823,
        estMonthlyUnits: 5372,
        estMonthlyRevenue: 100828,
        capturedSearchVol: 28625,
        revVolRatio: 3.52,
        top15Positions: 100,
      },
      {
        id: "p9",
        position: 9,
        isHero: false,
        brand: "First Aid Beauty",
        title: "First Aid Beauty - L",
        asin: "B08M3S38W9",
        imageUrl: "/placeholder.svg",
        reviews: 704,
        rating: 4.6,
        price: 23.25,
        bsr: 10769,
        estMonthlyUnits: 1941,
        estMonthlyRevenue: 44531,
        capturedSearchVol: 41831,
        revVolRatio: 1.06,
        top15Positions: 121,
      },
      {
        id: "p10",
        position: 10,
        isHero: false,
        brand: "Anthony",
        title: "Anthony Instant Fix",
        asin: "B00MRFQC6C",
        imageUrl: "/placeholder.svg",
        reviews: 561,
        rating: 4,
        price: 30.00,
        bsr: 43653,
        estMonthlyUnits: 402,
        estMonthlyRevenue: 11574,
        capturedSearchVol: 8797,
        revVolRatio: 1.32,
        top15Positions: 48,
      },
    ],
    keywords: [
      {
        id: "k1",
        keyword: "matte sunscreen",
        competitors: 1000,
        exactVol: 771,
        ranks: [18, null, 9, null, 175, null, 154, null, null, null],
        kpg: 64,
        search_volume: -37,
        ppc_max_bid: 2.43,
        hero_relevance: 81,
      },
      {
        id: "k2",
        keyword: "matte sunscreen for oily skin",
        competitors: 962,
        exactVol: 238,
        ranks: [23, null, 3, 227, 10, 56, 7, null, null, null],
        kpg: 63,
        search_volume: -32,
        ppc_max_bid: 2.13,
        hero_relevance: 81,
      },
      {
        id: "k3",
        keyword: "sunscreen matte",
        competitors: 1000,
        exactVol: 228,
        ranks: [14, null, 10, null, 120, null, 211, null, null, null],
        kpg: 63,
        search_volume: -33,
        ppc_max_bid: 2.40,
        hero_relevance: 80,
      },
      {
        id: "k4",
        keyword: "supergoop sunscreen",
        competitors: 210,
        exactVol: 15699,
        ranks: [7, null, null, null, null, null, null, null, null, null],
        kpg: 59,
        search_volume: -48,
        ppc_max_bid: 2.40,
        hero_relevance: 77,
      },
      {
        id: "k5",
        keyword: "sunscreen for oily skin",
        competitors: 5000,
        exactVol: 1211,
        ranks: [57, null, 39, null, 8, 142, 11, 277, null, null],
        kpg: 59,
        search_volume: -35,
        ppc_max_bid: 2.25,
        hero_relevance: 76,
      },
      {
        id: "k6",
        keyword: "oil control sunscreen",
        competitors: 803,
        exactVol: 261,
        ranks: [33, null, 153, null, 4, 19, 2, null, 131, 208],
        kpg: 59,
        search_volume: -20,
        ppc_max_bid: 2.14,
        hero_relevance: 77,
      },
      {
        id: "k7",
        keyword: "sunscreen oily skin",
        competitors: 5000,
        exactVol: 237,
        ranks: [16, null, 55, 237, 5, 149, 17, 242, null, null],
        kpg: 59,
        search_volume: -24,
        ppc_max_bid: 2.45,
        hero_relevance: 75,
      },
      {
        id: "k8",
        keyword: "matte sunscreen for face",
        competitors: 1000,
        exactVol: 426,
        ranks: [129, null, 9, 250, 23, null, 229, null, null, null],
        kpg: 58,
        search_volume: -47,
        ppc_max_bid: 2.38,
        hero_relevance: 81,
      },
      {
        id: "k9",
        keyword: "spf moisturizer face oily skin",
        competitors: 2000,
        exactVol: 223,
        ranks: [97, 108, 2, 107, 1, 31, 4, 237, null, 206],
        kpg: 58,
        search_volume: -32,
        ppc_max_bid: 3.18,
        hero_relevance: 73,
      },
      {
        id: "k10",
        keyword: "matte moisturizer with spf",
        competitors: 1000,
        exactVol: 177,
        ranks: [14, 9, 1, 169, 3, 184, 4, null, null, 222],
        kpg: 58,
        search_volume: -20,
        ppc_max_bid: 2.64,
        hero_relevance: 79,
      },
      {
        id: "k11",
        keyword: "mineral sunscreen for oily skin",
        competitors: 1000,
        exactVol: 53,
        ranks: [30, null, null, null, 26, null, 8, null, null, null],
        kpg: 58,
        search_volume: -24,
        ppc_max_bid: 2.38,
        hero_relevance: 79,
      },
      {
        id: "k12",
        keyword: "acne sunscreen",
        competitors: 2000,
        exactVol: 288,
        ranks: [78, 234, 239, null, 21, null, 10, 231, null, null],
        kpg: 57,
        search_volume: -19,
        ppc_max_bid: 2.08,
        hero_relevance: 72,
      },
      {
        id: "k13",
        keyword: "spf for oily skin",
        competitors: 4000,
        exactVol: 223,
        ranks: [60, null, 5, 186, 1, 46, 6, 232, 191, null],
        kpg: 57,
        search_volume: -24,
        ppc_max_bid: 2.01,
        hero_relevance: 76,
      },
      {
        id: "k14",
        keyword: "oil free spf face moisturizer",
        competitors: 667,
        exactVol: 201,
        ranks: [191, 243, 210, 218, 5, 219, 107, 251, 202, 244],
        kpg: 57,
        search_volume: -15,
        ppc_max_bid: 1.19,
        hero_relevance: 75,
      },
      {
        id: "k15",
        keyword: "sunscreen oil control",
        competitors: 505,
        exactVol: 175,
        ranks: [28, null, 25, null, 3, 8, 2, null, 51, null],
        kpg: 57,
        search_volume: -17,
        ppc_max_bid: 2.33,
        hero_relevance: 75,
      },
      {
        id: "k16",
        keyword: "oily skin sunscreen",
        competitors: 5000,
        exactVol: 275,
        ranks: [52, null, 28, null, 6, 87, 12, null, 229, 26],
        kpg: 56,
        search_volume: -24,
        ppc_max_bid: 2.33,
        hero_relevance: 75,
      },
      {
        id: "k17",
        keyword: "matte moisturizer for oily skin",
        competitors: 2000,
        exactVol: 273,
        ranks: [195, 2, 14, 25, 13, 3, 4, 95, 5, null],
        kpg: 56,
        search_volume: -34,
        ppc_max_bid: 2.64,
        hero_relevance: 74,
      },
      {
        id: "k18",
        keyword: "face sunscreen for oily skin",
        competitors: 4000,
        exactVol: 221,
        ranks: [59, 200, 31, 217, 5, 60, 12, null, null, null],
        kpg: 56,
        search_volume: -24,
        ppc_max_bid: 2.33,
        hero_relevance: 75,
      },
    ],
  },
  // Add entries for other landscape instances
  "1-1-3": {
    id: "1-1-3",
    prioritySearchPhrase: "chemical free sunscreen",
    date: "Jan 12, 2026",
    totals: {
      relevantKeywords: 1850,
      exactVolume: 654321,
      monthlyUnits: 18765,
    },
    products: [
      {
        id: "p1",
        position: 1,
        isHero: true,
        brand: "Supergoop!",
        title: "Supergoop! Mineral Mattescreen (SPF 40)",
        asin: "B09JVX2NNR",
        imageUrl: "/placeholder.svg",
        reviews: 1373,
        rating: 4.6,
        price: 39.95,
        bsr: 6517,
        estMonthlyUnits: 6580,
        estMonthlyRevenue: 256839,
        capturedSearchVol: 74415,
        revVolRatio: 3.45,
        top15Positions: 327,
      },
      {
        id: "p2",
        position: 2,
        isHero: false,
        brand: "Blue Lizard",
        title: "Blue Lizard Mineral Sunscreen SPF 50+",
        asin: "B07T2VH5K9",
        imageUrl: "/placeholder.svg",
        reviews: 12450,
        rating: 4.7,
        price: 17.99,
        bsr: 412,
        estMonthlyUnits: 24500,
        estMonthlyRevenue: 440755,
        capturedSearchVol: 198000,
        revVolRatio: 2.23,
        top15Positions: 612,
      },
      {
        id: "p3",
        position: 3,
        isHero: false,
        brand: "Neutrogena",
        title: "Neutrogena Sheer Zinc Mineral Sunscreen",
        asin: "B01HOHBS7K",
        imageUrl: "/placeholder.svg",
        reviews: 8934,
        rating: 4.4,
        price: 12.97,
        bsr: 834,
        estMonthlyUnits: 19200,
        estMonthlyRevenue: 249024,
        capturedSearchVol: 156000,
        revVolRatio: 1.60,
        top15Positions: 489,
      },
      {
        id: "p4",
        position: 4,
        isHero: false,
        brand: "ThinkBaby",
        title: "ThinkBaby Safe Sunscreen SPF 50+",
        asin: "B004CDQ9EQ",
        imageUrl: "/placeholder.svg",
        reviews: 15600,
        rating: 4.6,
        price: 14.99,
        bsr: 567,
        estMonthlyUnits: 21800,
        estMonthlyRevenue: 326782,
        capturedSearchVol: 178500,
        revVolRatio: 1.83,
        top15Positions: 534,
      },
      {
        id: "p5",
        position: 5,
        isHero: false,
        brand: "Badger",
        title: "Badger Reef Safe Sunscreen SPF 40",
        asin: "B07NPFWC8H",
        imageUrl: "/placeholder.svg",
        reviews: 6780,
        rating: 4.3,
        price: 18.49,
        bsr: 1234,
        estMonthlyUnits: 14500,
        estMonthlyRevenue: 268105,
        capturedSearchVol: 98000,
        revVolRatio: 2.74,
        top15Positions: 356,
      },
      {
        id: "p6",
        position: 6,
        isHero: false,
        brand: "Sun Bum",
        title: "Sun Bum Mineral SPF 50 Sunscreen",
        asin: "B01LZKHXAS",
        imageUrl: "/placeholder.svg",
        reviews: 11200,
        rating: 4.5,
        price: 15.99,
        bsr: 678,
        estMonthlyUnits: 18900,
        estMonthlyRevenue: 302211,
        capturedSearchVol: 145000,
        revVolRatio: 2.08,
        top15Positions: 478,
      },
      {
        id: "p7",
        position: 7,
        isHero: false,
        brand: "Coppertone",
        title: "Coppertone Pure & Simple SPF 50",
        asin: "B07N8X5VDN",
        imageUrl: "/placeholder.svg",
        reviews: 4560,
        rating: 4.2,
        price: 11.47,
        bsr: 1567,
        estMonthlyUnits: 12300,
        estMonthlyRevenue: 141081,
        capturedSearchVol: 87000,
        revVolRatio: 1.62,
        top15Positions: 298,
      },
      {
        id: "p8",
        position: 8,
        isHero: false,
        brand: "Aveeno",
        title: "Aveeno Positively Mineral SPF 50",
        asin: "B07TQ8BZ9F",
        imageUrl: "/placeholder.svg",
        reviews: 7890,
        rating: 4.4,
        price: 13.97,
        bsr: 923,
        estMonthlyUnits: 16700,
        estMonthlyRevenue: 233299,
        capturedSearchVol: 112000,
        revVolRatio: 2.08,
        top15Positions: 412,
      },
      {
        id: "p9",
        position: 9,
        isHero: false,
        brand: "Australian Gold",
        title: "Australian Gold Botanical SPF 50",
        asin: "B074JZ9VG6",
        imageUrl: "/placeholder.svg",
        reviews: 9870,
        rating: 4.5,
        price: 14.47,
        bsr: 789,
        estMonthlyUnits: 17800,
        estMonthlyRevenue: 257566,
        capturedSearchVol: 134000,
        revVolRatio: 1.92,
        top15Positions: 445,
      },
      {
        id: "p10",
        position: 10,
        isHero: false,
        brand: "Alba Botanica",
        title: "Alba Botanica Hawaiian Sunscreen SPF 45",
        asin: "B000HGDXHC",
        imageUrl: "/placeholder.svg",
        reviews: 5430,
        rating: 4.3,
        price: 10.99,
        bsr: 2134,
        estMonthlyUnits: 9800,
        estMonthlyRevenue: 107702,
        capturedSearchVol: 67000,
        revVolRatio: 1.61,
        top15Positions: 234,
      },
    ],
    keywords: [
      {
        id: "k1",
        keyword: "chemical free sunscreen",
        competitors: 1500,
        exactVol: 8920,
        ranks: [15, 3, 8, 5, 12, 9, 18, 22, 7, 35],
        kpg: 72,
        search_volume: -12,
        ppc_max_bid: 2.89,
        hero_relevance: 88,
      },
      {
        id: "k2",
        keyword: "mineral sunscreen",
        competitors: 2000,
        exactVol: 15600,
        ranks: [22, 1, 4, 6, 15, 8, 28, 12, 5, 42],
        kpg: 78,
        search_volume: 15,
        ppc_max_bid: 3.12,
        hero_relevance: 92,
      },
      {
        id: "k3",
        keyword: "reef safe sunscreen",
        competitors: 1200,
        exactVol: 6780,
        ranks: [45, 8, 12, 3, 6, 15, 52, 28, 9, 67],
        kpg: 68,
        search_volume: 8,
        ppc_max_bid: 2.67,
        hero_relevance: 85,
      },
      {
        id: "k4",
        keyword: "zinc oxide sunscreen",
        competitors: 890,
        exactVol: 4530,
        ranks: [18, 5, 9, 12, 22, 6, 35, 15, 8, 48],
        kpg: 64,
        search_volume: -5,
        ppc_max_bid: 2.45,
        hero_relevance: 82,
      },
      {
        id: "k5",
        keyword: "natural sunscreen for face",
        competitors: 1800,
        exactVol: 3450,
        ranks: [32, 15, 6, 8, 28, 12, 45, 18, 11, 58],
        kpg: 61,
        search_volume: -18,
        ppc_max_bid: 2.34,
        hero_relevance: 79,
      },
      {
        id: "k6",
        keyword: "organic sunscreen spf 50",
        competitors: 750,
        exactVol: 2890,
        ranks: [28, 12, 18, 5, 9, 22, 38, 25, 14, 52],
        kpg: 59,
        search_volume: 22,
        ppc_max_bid: 2.78,
        hero_relevance: 76,
      },
      {
        id: "k7",
        keyword: "non toxic sunscreen",
        competitors: 1100,
        exactVol: 5670,
        ranks: [12, 6, 15, 9, 18, 4, 28, 22, 8, 45],
        kpg: 70,
        search_volume: 5,
        ppc_max_bid: 2.56,
        hero_relevance: 87,
      },
      {
        id: "k8",
        keyword: "baby mineral sunscreen",
        competitors: 650,
        exactVol: 4120,
        ranks: [55, 18, 8, 2, 25, 35, 68, 42, 15, 78],
        kpg: 58,
        search_volume: -8,
        ppc_max_bid: 2.23,
        hero_relevance: 72,
      },
      {
        id: "k9",
        keyword: "face sunscreen no chemicals",
        competitors: 920,
        exactVol: 1890,
        ranks: [8, 22, 5, 15, 32, 18, 12, 28, 9, 45],
        kpg: 55,
        search_volume: -22,
        ppc_max_bid: 2.15,
        hero_relevance: 80,
      },
      {
        id: "k10",
        keyword: "sensitive skin sunscreen mineral",
        competitors: 780,
        exactVol: 2340,
        ranks: [25, 8, 12, 18, 6, 28, 42, 15, 22, 55],
        kpg: 57,
        search_volume: 12,
        ppc_max_bid: 2.42,
        hero_relevance: 78,
      },
      {
        id: "k11",
        keyword: "clean sunscreen",
        competitors: 1350,
        exactVol: 3890,
        ranks: [15, 9, 22, 12, 8, 18, 32, 25, 6, 48],
        kpg: 66,
        search_volume: 18,
        ppc_max_bid: 2.68,
        hero_relevance: 84,
      },
      {
        id: "k12",
        keyword: "physical sunscreen spf 50",
        competitors: 680,
        exactVol: 1560,
        ranks: [18, 5, 28, 8, 15, 12, 45, 22, 9, 62],
        kpg: 54,
        search_volume: -15,
        ppc_max_bid: 2.35,
        hero_relevance: 75,
      },
    ],
  },
  "1-2-2": {
    id: "1-2-2",
    prioritySearchPhrase: "matte sunscreen",
    date: "Oct 15, 2025",
    totals: {
      relevantKeywords: 1420,
      exactVolume: 456789,
      monthlyUnits: 12340,
    },
    products: [
      {
        id: "p1",
        position: 1,
        isHero: true,
        brand: "Supergoop!",
        title: "Supergoop! Mineral Mattescreen (SPF 40)",
        asin: "B09JVX2NNR",
        imageUrl: "/placeholder.svg",
        reviews: 1373,
        rating: 4.6,
        price: 39.95,
        bsr: 6517,
        estMonthlyUnits: 6580,
        estMonthlyRevenue: 256839,
        capturedSearchVol: 74415,
        revVolRatio: 3.45,
        top15Positions: 327,
      },
      {
        id: "p2",
        position: 2,
        isHero: false,
        brand: "e.l.f.",
        title: "e.l.f. Matte SPF 30 Sunscreen",
        asin: "B08XYQP9RJ",
        imageUrl: "/placeholder.svg",
        reviews: 8920,
        rating: 4.3,
        price: 12.00,
        bsr: 456,
        estMonthlyUnits: 22100,
        estMonthlyRevenue: 265200,
        capturedSearchVol: 189000,
        revVolRatio: 1.40,
        top15Positions: 598,
      },
      {
        id: "p3",
        position: 3,
        isHero: false,
        brand: "Paula's Choice",
        title: "Paula's Choice RESIST SPF 30 Matte",
        asin: "B00949CO4S",
        imageUrl: "/placeholder.svg",
        reviews: 5670,
        rating: 4.5,
        price: 33.00,
        bsr: 1890,
        estMonthlyUnits: 9800,
        estMonthlyRevenue: 323400,
        capturedSearchVol: 78000,
        revVolRatio: 4.15,
        top15Positions: 312,
      },
      {
        id: "p4",
        position: 4,
        isHero: false,
        brand: "Murad",
        title: "Murad Oil and Pore Control SPF 45",
        asin: "B00C0QZQG8",
        imageUrl: "/placeholder.svg",
        reviews: 3450,
        rating: 4.4,
        price: 48.00,
        bsr: 3456,
        estMonthlyUnits: 5600,
        estMonthlyRevenue: 268800,
        capturedSearchVol: 45000,
        revVolRatio: 5.97,
        top15Positions: 189,
      },
      {
        id: "p5",
        position: 5,
        isHero: false,
        brand: "CeraVe",
        title: "CeraVe Ultra-Light Moisturizing SPF 30",
        asin: "B0C7HMKH3G",
        imageUrl: "/placeholder.svg",
        reviews: 4005,
        rating: 4.7,
        price: 16.18,
        bsr: 1056,
        estMonthlyUnits: 18051,
        estMonthlyRevenue: 283514,
        capturedSearchVol: 228352,
        revVolRatio: 1.24,
        top15Positions: 545,
      },
      {
        id: "p6",
        position: 6,
        isHero: false,
        brand: "EltaMD",
        title: "EltaMD UV Clear SPF 46",
        asin: "B002MSN3QQ",
        imageUrl: "/placeholder.svg",
        reviews: 18900,
        rating: 4.6,
        price: 41.00,
        bsr: 234,
        estMonthlyUnits: 28900,
        estMonthlyRevenue: 1184900,
        capturedSearchVol: 312000,
        revVolRatio: 3.80,
        top15Positions: 678,
      },
      {
        id: "p7",
        position: 7,
        isHero: false,
        brand: "La Roche-Posay",
        title: "La Roche-Posay Anthelios Melt-In",
        asin: "B002CML1VG",
        imageUrl: "/placeholder.svg",
        reviews: 12340,
        rating: 4.5,
        price: 35.99,
        bsr: 567,
        estMonthlyUnits: 19800,
        estMonthlyRevenue: 712602,
        capturedSearchVol: 256000,
        revVolRatio: 2.78,
        top15Positions: 589,
      },
      {
        id: "p8",
        position: 8,
        isHero: false,
        brand: "Neutrogena",
        title: "Neutrogena Clear Face SPF 55",
        asin: "B004D2826K",
        imageUrl: "/placeholder.svg",
        reviews: 9870,
        rating: 4.3,
        price: 14.97,
        bsr: 890,
        estMonthlyUnits: 16500,
        estMonthlyRevenue: 247005,
        capturedSearchVol: 189000,
        revVolRatio: 1.31,
        top15Positions: 478,
      },
      {
        id: "p9",
        position: 9,
        isHero: false,
        brand: "Tatcha",
        title: "Tatcha Silken Pore Perfecting SPF 35",
        asin: "B074WKKD7K",
        imageUrl: "/placeholder.svg",
        reviews: 2890,
        rating: 4.4,
        price: 65.00,
        bsr: 5678,
        estMonthlyUnits: 3200,
        estMonthlyRevenue: 208000,
        capturedSearchVol: 34000,
        revVolRatio: 6.12,
        top15Positions: 145,
      },
      {
        id: "p10",
        position: 10,
        isHero: false,
        brand: "Olay",
        title: "Olay Regenerist Whip SPF 40",
        asin: "B07BHKQJ2K",
        imageUrl: "/placeholder.svg",
        reviews: 7650,
        rating: 4.4,
        price: 28.94,
        bsr: 1234,
        estMonthlyUnits: 14200,
        estMonthlyRevenue: 410948,
        capturedSearchVol: 167000,
        revVolRatio: 2.46,
        top15Positions: 423,
      },
    ],
    keywords: [
      {
        id: "k1",
        keyword: "matte sunscreen spf",
        competitors: 800,
        exactVol: 5670,
        ranks: [8, 12, 5, 28, 15, 6, 9, 22, 45, 18],
        kpg: 72,
        search_volume: -22,
        ppc_max_bid: 2.55,
        hero_relevance: 89,
      },
      {
        id: "k2",
        keyword: "matte finish sunscreen",
        competitors: 650,
        exactVol: 3450,
        ranks: [5, 8, 12, 35, 9, 4, 15, 28, 52, 22],
        kpg: 68,
        search_volume: -15,
        ppc_max_bid: 2.48,
        hero_relevance: 86,
      },
      {
        id: "k3",
        keyword: "no shine sunscreen",
        competitors: 520,
        exactVol: 2890,
        ranks: [12, 5, 18, 42, 8, 9, 22, 15, 68, 28],
        kpg: 62,
        search_volume: 8,
        ppc_max_bid: 2.12,
        hero_relevance: 82,
      },
      {
        id: "k4",
        keyword: "oil control sunscreen face",
        competitors: 780,
        exactVol: 4120,
        ranks: [18, 22, 8, 15, 5, 12, 28, 9, 45, 35],
        kpg: 65,
        search_volume: -28,
        ppc_max_bid: 2.34,
        hero_relevance: 84,
      },
      {
        id: "k5",
        keyword: "mattifying spf moisturizer",
        competitors: 450,
        exactVol: 1780,
        ranks: [6, 15, 3, 48, 12, 8, 18, 25, 72, 32],
        kpg: 58,
        search_volume: -12,
        ppc_max_bid: 2.67,
        hero_relevance: 88,
      },
      {
        id: "k6",
        keyword: "sunscreen for oily skin matte",
        competitors: 890,
        exactVol: 3670,
        ranks: [15, 9, 12, 22, 6, 18, 8, 28, 55, 25],
        kpg: 64,
        search_volume: -18,
        ppc_max_bid: 2.45,
        hero_relevance: 85,
      },
      {
        id: "k7",
        keyword: "pore minimizing sunscreen",
        competitors: 380,
        exactVol: 1450,
        ranks: [22, 18, 9, 12, 28, 5, 15, 35, 62, 42],
        kpg: 56,
        search_volume: 15,
        ppc_max_bid: 2.89,
        hero_relevance: 79,
      },
      {
        id: "k8",
        keyword: "anti shine spf",
        competitors: 290,
        exactVol: 980,
        ranks: [9, 12, 22, 38, 15, 8, 28, 18, 78, 35],
        kpg: 52,
        search_volume: -8,
        ppc_max_bid: 1.98,
        hero_relevance: 76,
      },
      {
        id: "k9",
        keyword: "shine free sunscreen",
        competitors: 560,
        exactVol: 2340,
        ranks: [8, 15, 6, 32, 12, 9, 22, 28, 58, 42],
        kpg: 60,
        search_volume: 5,
        ppc_max_bid: 2.23,
        hero_relevance: 81,
      },
      {
        id: "k10",
        keyword: "velvet finish spf",
        competitors: 210,
        exactVol: 670,
        ranks: [4, 28, 8, 55, 18, 12, 35, 22, 85, 48],
        kpg: 48,
        search_volume: 28,
        ppc_max_bid: 2.78,
        hero_relevance: 74,
      },
    ],
  },
  // Additional instances for "mattifying lotion" to show version history
  "1-4-2": {
    id: "1-4-2",
    prioritySearchPhrase: "mattifying lotion",
    date: "Oct 28, 2025",
    totals: {
      relevantKeywords: 1980,
      exactVolume: 756000,
      monthlyUnits: 20100,
    },
    products: [
      {
        id: "p1",
        position: 1,
        isHero: true,
        brand: "Supergoop!",
        title: "Supergoop! Mineral Mattescreen (SPF 40)",
        asin: "B09JVX2NNR",
        imageUrl: "/placeholder.svg",
        reviews: 1320,
        rating: 4.5,
        price: 39.95,
        bsr: 6800,
        estMonthlyUnits: 6200,
        estMonthlyRevenue: 247590,
        capturedSearchVol: 71000,
        revVolRatio: 3.48,
        top15Positions: 310,
      },
      {
        id: "p2",
        position: 2,
        isHero: false,
        brand: "Cetaphil",
        title: "Cetaphil Face Moisturizer",
        asin: "B093W4D1T3",
        imageUrl: "/placeholder.svg",
        reviews: 9450,
        rating: 4.5,
        price: 10.97,
        bsr: 780,
        estMonthlyUnits: 17500,
        estMonthlyRevenue: 185975,
        capturedSearchVol: 175000,
        revVolRatio: 1.06,
        top15Positions: 515,
      },
      {
        id: "p3",
        position: 3,
        isHero: false,
        brand: "La Roche-Posay",
        title: "La Roche-Posay Toleriane",
        asin: "B09N13T8TL",
        imageUrl: "/placeholder.svg",
        reviews: 7890,
        rating: 4.5,
        price: 24.99,
        bsr: 1100,
        estMonthlyUnits: 20800,
        estMonthlyRevenue: 484792,
        capturedSearchVol: 258000,
        revVolRatio: 1.88,
        top15Positions: 498,
      },
      {
        id: "p4",
        position: 4,
        isHero: false,
        brand: "CeraVe",
        title: "CeraVe Ultra-Light Moisturizing",
        asin: "B0C7HMKH3G",
        imageUrl: "/placeholder.svg",
        reviews: 3800,
        rating: 4.7,
        price: 16.18,
        bsr: 1100,
        estMonthlyUnits: 17500,
        estMonthlyRevenue: 274850,
        capturedSearchVol: 222000,
        revVolRatio: 1.24,
        top15Positions: 530,
      },
      {
        id: "p5",
        position: 5,
        isHero: false,
        brand: "Cetaphil",
        title: "Cetaphil DermaCo",
        asin: "B076D1961B",
        imageUrl: "/placeholder.svg",
        reviews: 15200,
        rating: 4.4,
        price: 14.38,
        bsr: 3400,
        estMonthlyUnits: 8400,
        estMonthlyRevenue: 116424,
        capturedSearchVol: 98000,
        revVolRatio: 1.19,
        top15Positions: 358,
      },
      {
        id: "p6",
        position: 6,
        isHero: false,
        brand: "CeraVe",
        title: "CeraVe Oil Control Moisturizer",
        asin: "B0CTTv9126",
        imageUrl: "/placeholder.svg",
        reviews: 1850,
        rating: 4.6,
        price: 16.18,
        bsr: 1950,
        estMonthlyUnits: 10200,
        estMonthlyRevenue: 159236,
        capturedSearchVol: 218000,
        revVolRatio: 0.73,
        top15Positions: 558,
      },
      {
        id: "p7",
        position: 7,
        isHero: false,
        brand: "PanOxyl",
        title: "PanOxyl AM Oil Control",
        asin: "B09583P2PR",
        imageUrl: "/placeholder.svg",
        reviews: 1250,
        rating: 4.4,
        price: 10.42,
        bsr: 5200,
        estMonthlyUnits: 5400,
        estMonthlyRevenue: 52962,
        capturedSearchVol: 65000,
        revVolRatio: 0.81,
        top15Positions: 232,
      },
      {
        id: "p8",
        position: 8,
        isHero: false,
        brand: "COSRX",
        title: "COSRX Oil Free Lotion",
        asin: "B01CLTX14A",
        imageUrl: "/placeholder.svg",
        reviews: 7100,
        rating: 4.6,
        price: 18.99,
        bsr: 6000,
        estMonthlyUnits: 5200,
        estMonthlyRevenue: 97598,
        capturedSearchVol: 27500,
        revVolRatio: 3.55,
        top15Positions: 95,
      },
      {
        id: "p9",
        position: 9,
        isHero: false,
        brand: "First Aid Beauty",
        title: "First Aid Beauty - L",
        asin: "B08M3S38W9",
        imageUrl: "/placeholder.svg",
        reviews: 680,
        rating: 4.6,
        price: 23.25,
        bsr: 11200,
        estMonthlyUnits: 1850,
        estMonthlyRevenue: 42437,
        capturedSearchVol: 40000,
        revVolRatio: 1.06,
        top15Positions: 115,
      },
      {
        id: "p10",
        position: 10,
        isHero: false,
        brand: "Anthony",
        title: "Anthony Instant Fix",
        asin: "B00MRFQC6C",
        imageUrl: "/placeholder.svg",
        reviews: 540,
        rating: 4,
        price: 30.00,
        bsr: 45000,
        estMonthlyUnits: 380,
        estMonthlyRevenue: 10944,
        capturedSearchVol: 8500,
        revVolRatio: 1.29,
        top15Positions: 45,
      },
    ],
    keywords: [
      {
        id: "k1",
        keyword: "matte sunscreen",
        competitors: 1000,
        exactVol: 750,
        ranks: [22, null, 11, null, 180, null, 160, null, null, null],
        kpg: 62,
        search_volume: -35,
        ppc_max_bid: 2.38,
        hero_relevance: 79,
      },
      {
        id: "k2",
        keyword: "matte sunscreen for oily skin",
        competitors: 950,
        exactVol: 225,
        ranks: [25, null, 5, 235, 12, 60, 9, null, null, null],
        kpg: 61,
        search_volume: -30,
        ppc_max_bid: 2.10,
        hero_relevance: 79,
      },
      {
        id: "k3",
        keyword: "sunscreen matte finish",
        competitors: 980,
        exactVol: 215,
        ranks: [16, null, 12, null, 125, null, 220, null, null, null],
        kpg: 61,
        search_volume: -31,
        ppc_max_bid: 2.38,
        hero_relevance: 78,
      },
      {
        id: "k4",
        keyword: "supergoop sunscreen matte",
        competitors: 200,
        exactVol: 14800,
        ranks: [9, null, null, null, null, null, null, null, null, null],
        kpg: 57,
        search_volume: -45,
        ppc_max_bid: 2.35,
        hero_relevance: 75,
      },
      {
        id: "k5",
        keyword: "sunscreen for oily skin matte",
        competitors: 4800,
        exactVol: 1150,
        ranks: [60, null, 42, null, 10, 150, 14, 285, null, null],
        kpg: 57,
        search_volume: -33,
        ppc_max_bid: 2.22,
        hero_relevance: 74,
      },
      {
        id: "k6",
        keyword: "oil control sunscreen spf",
        competitors: 790,
        exactVol: 248,
        ranks: [35, null, 160, null, 6, 22, 4, null, 140, 220],
        kpg: 57,
        search_volume: -18,
        ppc_max_bid: 2.10,
        hero_relevance: 75,
      },
      {
        id: "k7",
        keyword: "sunscreen oily skin matte",
        competitors: 4800,
        exactVol: 225,
        ranks: [18, null, 58, 245, 7, 155, 20, 250, null, null],
        kpg: 57,
        search_volume: -22,
        ppc_max_bid: 2.42,
        hero_relevance: 73,
      },
      {
        id: "k8",
        keyword: "matte sunscreen face spf",
        competitors: 980,
        exactVol: 410,
        ranks: [135, null, 11, 260, 25, null, 240, null, null, null],
        kpg: 56,
        search_volume: -45,
        ppc_max_bid: 2.35,
        hero_relevance: 79,
      },
      {
        id: "k9",
        keyword: "spf moisturizer oily skin matte",
        competitors: 1900,
        exactVol: 210,
        ranks: [102, 115, 4, 115, 3, 35, 6, 245, null, 215],
        kpg: 56,
        search_volume: -30,
        ppc_max_bid: 3.12,
        hero_relevance: 71,
      },
      {
        id: "k10",
        keyword: "matte moisturizer spf protection",
        competitors: 980,
        exactVol: 165,
        ranks: [16, 11, 3, 175, 5, 190, 6, null, null, 230],
        kpg: 56,
        search_volume: -18,
        ppc_max_bid: 2.58,
        hero_relevance: 77,
      },
      {
        id: "k11",
        keyword: "mineral sunscreen oily skin matte",
        competitors: 980,
        exactVol: 48,
        ranks: [32, null, null, null, 28, null, 10, null, null, null],
        kpg: 56,
        search_volume: -22,
        ppc_max_bid: 2.35,
        hero_relevance: 77,
      },
      {
        id: "k12",
        keyword: "acne sunscreen matte",
        competitors: 1900,
        exactVol: 275,
        ranks: [82, 242, 248, null, 24, null, 12, 240, null, null],
        kpg: 55,
        search_volume: -17,
        ppc_max_bid: 2.05,
        hero_relevance: 70,
      },
    ],
  },
  "1-4-3": {
    id: "1-4-3",
    prioritySearchPhrase: "mattifying lotion",
    date: "Oct 14, 2025",
    totals: {
      relevantKeywords: 1920,
      exactVolume: 720000,
      monthlyUnits: 19500,
    },
    products: [
      {
        id: "p1",
        position: 1,
        isHero: true,
        brand: "Supergoop!",
        title: "Supergoop! Mineral Mattescreen (SPF 40)",
        asin: "B09JVX2NNR",
        imageUrl: "/placeholder.svg",
        reviews: 1280,
        rating: 4.5,
        price: 38.95,
        bsr: 7100,
        estMonthlyUnits: 5900,
        estMonthlyRevenue: 229805,
        capturedSearchVol: 68000,
        revVolRatio: 3.38,
        top15Positions: 295,
      },
      {
        id: "p2",
        position: 2,
        isHero: false,
        brand: "Cetaphil",
        title: "Cetaphil Face Moisturizer",
        asin: "B093W4D1T3",
        imageUrl: "/placeholder.svg",
        reviews: 9200,
        rating: 4.5,
        price: 10.97,
        bsr: 810,
        estMonthlyUnits: 17000,
        estMonthlyRevenue: 180690,
        capturedSearchVol: 170000,
        revVolRatio: 1.06,
        top15Positions: 502,
      },
      {
        id: "p3",
        position: 3,
        isHero: false,
        brand: "La Roche-Posay",
        title: "La Roche-Posay Toleriane",
        asin: "B09N13T8TL",
        imageUrl: "/placeholder.svg",
        reviews: 7650,
        rating: 4.5,
        price: 24.99,
        bsr: 1150,
        estMonthlyUnits: 20200,
        estMonthlyRevenue: 470798,
        capturedSearchVol: 252000,
        revVolRatio: 1.87,
        top15Positions: 485,
      },
      {
        id: "p4",
        position: 4,
        isHero: false,
        brand: "CeraVe",
        title: "CeraVe Ultra-Light Moisturizing",
        asin: "B0C7HMKH3G",
        imageUrl: "/placeholder.svg",
        reviews: 3650,
        rating: 4.7,
        price: 16.18,
        bsr: 1150,
        estMonthlyUnits: 17000,
        estMonthlyRevenue: 267060,
        capturedSearchVol: 215000,
        revVolRatio: 1.24,
        top15Positions: 518,
      },
      {
        id: "p5",
        position: 5,
        isHero: false,
        brand: "Cetaphil",
        title: "Cetaphil DermaCo",
        asin: "B076D1961B",
        imageUrl: "/placeholder.svg",
        reviews: 14800,
        rating: 4.4,
        price: 14.38,
        bsr: 3550,
        estMonthlyUnits: 8100,
        estMonthlyRevenue: 112266,
        capturedSearchVol: 95000,
        revVolRatio: 1.18,
        top15Positions: 345,
      },
      {
        id: "p6",
        position: 6,
        isHero: false,
        brand: "CeraVe",
        title: "CeraVe Oil Control Moisturizer",
        asin: "B0CTTv9126",
        imageUrl: "/placeholder.svg",
        reviews: 1750,
        rating: 4.6,
        price: 16.18,
        bsr: 2050,
        estMonthlyUnits: 9800,
        estMonthlyRevenue: 152964,
        capturedSearchVol: 210000,
        revVolRatio: 0.73,
        top15Positions: 542,
      },
      {
        id: "p7",
        position: 7,
        isHero: false,
        brand: "PanOxyl",
        title: "PanOxyl AM Oil Control",
        asin: "B09583P2PR",
        imageUrl: "/placeholder.svg",
        reviews: 1200,
        rating: 4.4,
        price: 10.42,
        bsr: 5400,
        estMonthlyUnits: 5200,
        estMonthlyRevenue: 50960,
        capturedSearchVol: 62000,
        revVolRatio: 0.82,
        top15Positions: 220,
      },
      {
        id: "p8",
        position: 8,
        isHero: false,
        brand: "COSRX",
        title: "COSRX Oil Free Lotion",
        asin: "B01CLTX14A",
        imageUrl: "/placeholder.svg",
        reviews: 6900,
        rating: 4.6,
        price: 18.99,
        bsr: 6200,
        estMonthlyUnits: 5000,
        estMonthlyRevenue: 93850,
        capturedSearchVol: 26500,
        revVolRatio: 3.54,
        top15Positions: 90,
      },
      {
        id: "p9",
        position: 9,
        isHero: false,
        brand: "First Aid Beauty",
        title: "First Aid Beauty - L",
        asin: "B08M3S38W9",
        imageUrl: "/placeholder.svg",
        reviews: 650,
        rating: 4.6,
        price: 23.25,
        bsr: 11600,
        estMonthlyUnits: 1750,
        estMonthlyRevenue: 40143,
        capturedSearchVol: 38500,
        revVolRatio: 1.04,
        top15Positions: 108,
      },
      {
        id: "p10",
        position: 10,
        isHero: false,
        brand: "Anthony",
        title: "Anthony Instant Fix",
        asin: "B00MRFQC6C",
        imageUrl: "/placeholder.svg",
        reviews: 520,
        rating: 4,
        price: 30.00,
        bsr: 46500,
        estMonthlyUnits: 360,
        estMonthlyRevenue: 10368,
        capturedSearchVol: 8200,
        revVolRatio: 1.26,
        top15Positions: 42,
      },
    ],
    keywords: [
      {
        id: "k1",
        keyword: "matte sunscreen",
        competitors: 1000,
        exactVol: 720,
        ranks: [25, null, 14, null, 190, null, 170, null, null, null],
        kpg: 60,
        search_volume: -38,
        ppc_max_bid: 2.35,
        hero_relevance: 77,
      },
      {
        id: "k2",
        keyword: "matte sunscreen for oily skin",
        competitors: 940,
        exactVol: 212,
        ranks: [28, null, 7, 242, 14, 65, 11, null, null, null],
        kpg: 59,
        search_volume: -28,
        ppc_max_bid: 2.08,
        hero_relevance: 77,
      },
      {
        id: "k3",
        keyword: "sunscreen matte",
        competitors: 970,
        exactVol: 202,
        ranks: [18, null, 15, null, 132, null, 228, null, null, null],
        kpg: 59,
        search_volume: -29,
        ppc_max_bid: 2.36,
        hero_relevance: 76,
      },
      {
        id: "k4",
        keyword: "supergoop sunscreen",
        competitors: 195,
        exactVol: 14200,
        ranks: [11, null, null, null, null, null, null, null, null, null],
        kpg: 55,
        search_volume: -42,
        ppc_max_bid: 2.32,
        hero_relevance: 73,
      },
      {
        id: "k5",
        keyword: "sunscreen for oily skin",
        competitors: 4700,
        exactVol: 1100,
        ranks: [65, null, 45, null, 12, 158, 16, 292, null, null],
        kpg: 55,
        search_volume: -31,
        ppc_max_bid: 2.20,
        hero_relevance: 72,
      },
      {
        id: "k6",
        keyword: "oil control sunscreen",
        competitors: 780,
        exactVol: 238,
        ranks: [38, null, 168, null, 8, 25, 5, null, 148, 228],
        kpg: 55,
        search_volume: -16,
        ppc_max_bid: 2.08,
        hero_relevance: 73,
      },
      {
        id: "k7",
        keyword: "sunscreen oily skin",
        competitors: 4700,
        exactVol: 215,
        ranks: [20, null, 62, 252, 8, 162, 22, 258, null, null],
        kpg: 55,
        search_volume: -20,
        ppc_max_bid: 2.40,
        hero_relevance: 71,
      },
      {
        id: "k8",
        keyword: "matte sunscreen for face",
        competitors: 970,
        exactVol: 395,
        ranks: [142, null, 14, 268, 28, null, 248, null, null, null],
        kpg: 54,
        search_volume: -42,
        ppc_max_bid: 2.32,
        hero_relevance: 77,
      },
      {
        id: "k9",
        keyword: "spf moisturizer face oily skin",
        competitors: 1850,
        exactVol: 198,
        ranks: [108, 122, 6, 122, 4, 38, 8, 252, null, 222],
        kpg: 54,
        search_volume: -28,
        ppc_max_bid: 3.08,
        hero_relevance: 69,
      },
      {
        id: "k10",
        keyword: "matte moisturizer with spf",
        competitors: 970,
        exactVol: 158,
        ranks: [18, 14, 4, 182, 6, 198, 8, null, null, 238],
        kpg: 54,
        search_volume: -16,
        ppc_max_bid: 2.55,
        hero_relevance: 75,
      },
      {
        id: "k11",
        keyword: "mineral sunscreen for oily skin",
        competitors: 970,
        exactVol: 45,
        ranks: [35, null, null, null, 30, null, 12, null, null, null],
        kpg: 54,
        search_volume: -20,
        ppc_max_bid: 2.32,
        hero_relevance: 75,
      },
      {
        id: "k12",
        keyword: "acne sunscreen",
        competitors: 1850,
        exactVol: 265,
        ranks: [88, 250, 255, null, 26, null, 14, 248, null, null],
        kpg: 53,
        search_volume: -15,
        ppc_max_bid: 2.02,
        hero_relevance: 68,
      },
      {
        id: "k13",
        keyword: "spf for oily skin",
        competitors: 3800,
        exactVol: 205,
        ranks: [68, null, 8, 195, 3, 52, 9, 242, 202, null],
        kpg: 53,
        search_volume: -20,
        ppc_max_bid: 1.98,
        hero_relevance: 72,
      },
      {
        id: "k14",
        keyword: "oil free spf face moisturizer",
        competitors: 650,
        exactVol: 188,
        ranks: [198, 252, 218, 228, 8, 228, 115, 260, 212, 252],
        kpg: 53,
        search_volume: -12,
        ppc_max_bid: 1.15,
        hero_relevance: 71,
      },
      {
        id: "k15",
        keyword: "sunscreen oil control",
        competitors: 490,
        exactVol: 162,
        ranks: [32, null, 28, null, 5, 10, 4, null, 58, null],
        kpg: 53,
        search_volume: -14,
        ppc_max_bid: 2.28,
        hero_relevance: 71,
      },
    ],
  },
  // Additional instances for "chemical free sunscreen"
  "1-1-2": {
    id: "1-1-2",
    prioritySearchPhrase: "chemical free sunscreen",
    date: "Oct 14, 2025",
    totals: {
      relevantKeywords: 1720,
      exactVolume: 612400,
      monthlyUnits: 17200,
    },
    products: [
      { id: "p1", position: 1, isHero: true, brand: "Supergoop!", title: "Supergoop! Mineral Mattescreen (SPF 40)", asin: "B09JVX2NNR", imageUrl: "/placeholder.svg", reviews: 1280, rating: 4.5, price: 39.95, bsr: 7200, estMonthlyUnits: 6100, estMonthlyRevenue: 243695, capturedSearchVol: 70200, revVolRatio: 3.47, top15Positions: 310 },
      { id: "p2", position: 2, isHero: false, brand: "Blue Lizard", title: "Blue Lizard Mineral Sunscreen SPF 50+", asin: "B07T2VH5K9", imageUrl: "/placeholder.svg", reviews: 11800, rating: 4.7, price: 17.99, bsr: 450, estMonthlyUnits: 23200, estMonthlyRevenue: 417368, capturedSearchVol: 190000, revVolRatio: 2.20, top15Positions: 598 },
      { id: "p3", position: 3, isHero: false, brand: "Neutrogena", title: "Neutrogena Sheer Zinc Mineral Sunscreen", asin: "B01HOHBS7K", imageUrl: "/placeholder.svg", reviews: 8500, rating: 4.4, price: 12.97, bsr: 890, estMonthlyUnits: 18500, estMonthlyRevenue: 239945, capturedSearchVol: 150000, revVolRatio: 1.60, top15Positions: 475 },
      { id: "p4", position: 4, isHero: false, brand: "ThinkBaby", title: "ThinkBaby Safe Sunscreen SPF 50+", asin: "B004CDQ9EQ", imageUrl: "/placeholder.svg", reviews: 15200, rating: 4.6, price: 14.99, bsr: 590, estMonthlyUnits: 21000, estMonthlyRevenue: 314790, capturedSearchVol: 172000, revVolRatio: 1.83, top15Positions: 520 },
      { id: "p5", position: 5, isHero: false, brand: "Badger", title: "Badger Reef Safe Sunscreen SPF 40", asin: "B07NPFWC8H", imageUrl: "/placeholder.svg", reviews: 6500, rating: 4.3, price: 18.49, bsr: 1300, estMonthlyUnits: 13800, estMonthlyRevenue: 255162, capturedSearchVol: 94000, revVolRatio: 2.71, top15Positions: 340 },
      { id: "p6", position: 6, isHero: false, brand: "Sun Bum", title: "Sun Bum Mineral SPF 50 Sunscreen", asin: "B01LZKHXAS", imageUrl: "/placeholder.svg", reviews: 10800, rating: 4.5, price: 15.99, bsr: 720, estMonthlyUnits: 18000, estMonthlyRevenue: 287820, capturedSearchVol: 140000, revVolRatio: 2.06, top15Positions: 460 },
      { id: "p7", position: 7, isHero: false, brand: "Coppertone", title: "Coppertone Pure & Simple SPF 50", asin: "B07N8X5VDN", imageUrl: "/placeholder.svg", reviews: 4300, rating: 4.2, price: 11.47, bsr: 1600, estMonthlyUnits: 11800, estMonthlyRevenue: 135346, capturedSearchVol: 83000, revVolRatio: 1.63, top15Positions: 285 },
      { id: "p8", position: 8, isHero: false, brand: "Aveeno", title: "Aveeno Positively Mineral SPF 50", asin: "B07TQ8BZ9F", imageUrl: "/placeholder.svg", reviews: 7500, rating: 4.4, price: 13.97, bsr: 980, estMonthlyUnits: 16000, estMonthlyRevenue: 223520, capturedSearchVol: 108000, revVolRatio: 2.07, top15Positions: 400 },
      { id: "p9", position: 9, isHero: false, brand: "Australian Gold", title: "Australian Gold Botanical SPF 50", asin: "B074JZ9VG6", imageUrl: "/placeholder.svg", reviews: 9500, rating: 4.5, price: 14.47, bsr: 820, estMonthlyUnits: 17000, estMonthlyRevenue: 245990, capturedSearchVol: 130000, revVolRatio: 1.89, top15Positions: 430 },
      { id: "p10", position: 10, isHero: false, brand: "Alba Botanica", title: "Alba Botanica Hawaiian Sunscreen SPF 45", asin: "B000HGDXHC", imageUrl: "/placeholder.svg", reviews: 5200, rating: 4.3, price: 10.99, bsr: 2200, estMonthlyUnits: 9400, estMonthlyRevenue: 103306, capturedSearchVol: 64000, revVolRatio: 1.61, top15Positions: 225 },
    ],
    keywords: [
    ],
  },
  "1-1-1": {
    id: "1-1-1",
    prioritySearchPhrase: "chemical free sunscreen",
    date: "Oct 08, 2025",
    totals: {
      relevantKeywords: 1640,
      exactVolume: 580200,
      monthlyUnits: 15800,
    },
    products: [
      { id: "p1", position: 1, isHero: true, brand: "Supergoop!", title: "Supergoop! Mineral Mattescreen (SPF 40)", asin: "B09JVX2NNR", imageUrl: "/placeholder.svg", reviews: 1200, rating: 4.5, price: 39.95, bsr: 7800, estMonthlyUnits: 5700, estMonthlyRevenue: 227715, capturedSearchVol: 65800, revVolRatio: 3.46, top15Positions: 295 },
      { id: "p2", position: 2, isHero: false, brand: "Blue Lizard", title: "Blue Lizard Mineral Sunscreen SPF 50+", asin: "B07T2VH5K9", imageUrl: "/placeholder.svg", reviews: 11200, rating: 4.7, price: 17.99, bsr: 480, estMonthlyUnits: 22000, estMonthlyRevenue: 395780, capturedSearchVol: 182000, revVolRatio: 2.17, top15Positions: 580 },
      { id: "p3", position: 3, isHero: false, brand: "Neutrogena", title: "Neutrogena Sheer Zinc Mineral Sunscreen", asin: "B01HOHBS7K", imageUrl: "/placeholder.svg", reviews: 8200, rating: 4.4, price: 12.97, bsr: 920, estMonthlyUnits: 17800, estMonthlyRevenue: 230866, capturedSearchVol: 145000, revVolRatio: 1.59, top15Positions: 462 },
      { id: "p4", position: 4, isHero: false, brand: "ThinkBaby", title: "ThinkBaby Safe Sunscreen SPF 50+", asin: "B004CDQ9EQ", imageUrl: "/placeholder.svg", reviews: 14800, rating: 4.6, price: 14.99, bsr: 610, estMonthlyUnits: 20200, estMonthlyRevenue: 302798, capturedSearchVol: 165000, revVolRatio: 1.84, top15Positions: 505 },
      { id: "p5", position: 5, isHero: false, brand: "Badger", title: "Badger Reef Safe Sunscreen SPF 40", asin: "B07NPFWC8H", imageUrl: "/placeholder.svg", reviews: 6200, rating: 4.3, price: 18.49, bsr: 1350, estMonthlyUnits: 13200, estMonthlyRevenue: 244068, capturedSearchVol: 90000, revVolRatio: 2.71, top15Positions: 325 },
      { id: "p6", position: 6, isHero: false, brand: "Sun Bum", title: "Sun Bum Mineral SPF 50 Sunscreen", asin: "B01LZKHXAS", imageUrl: "/placeholder.svg", reviews: 10400, rating: 4.5, price: 15.99, bsr: 750, estMonthlyUnits: 17200, estMonthlyRevenue: 275028, capturedSearchVol: 135000, revVolRatio: 2.04, top15Positions: 445 },
      { id: "p7", position: 7, isHero: false, brand: "Coppertone", title: "Coppertone Pure & Simple SPF 50", asin: "B07N8X5VDN", imageUrl: "/placeholder.svg", reviews: 4100, rating: 4.2, price: 11.47, bsr: 1650, estMonthlyUnits: 11200, estMonthlyRevenue: 128464, capturedSearchVol: 79000, revVolRatio: 1.63, top15Positions: 272 },
      { id: "p8", position: 8, isHero: false, brand: "Aveeno", title: "Aveeno Positively Mineral SPF 50", asin: "B07TQ8BZ9F", imageUrl: "/placeholder.svg", reviews: 7200, rating: 4.4, price: 13.97, bsr: 1020, estMonthlyUnits: 15400, estMonthlyRevenue: 215138, capturedSearchVol: 104000, revVolRatio: 2.07, top15Positions: 388 },
      { id: "p9", position: 9, isHero: false, brand: "Australian Gold", title: "Australian Gold Botanical SPF 50", asin: "B074JZ9VG6", imageUrl: "/placeholder.svg", reviews: 9200, rating: 4.5, price: 14.47, bsr: 850, estMonthlyUnits: 16400, estMonthlyRevenue: 237308, capturedSearchVol: 126000, revVolRatio: 1.88, top15Positions: 418 },
      { id: "p10", position: 10, isHero: false, brand: "Alba Botanica", title: "Alba Botanica Hawaiian Sunscreen SPF 45", asin: "B000HGDXHC", imageUrl: "/placeholder.svg", reviews: 5000, rating: 4.3, price: 10.99, bsr: 2300, estMonthlyUnits: 9000, estMonthlyRevenue: 98910, capturedSearchVol: 61000, revVolRatio: 1.62, top15Positions: 215 },
    ],
    keywords: [
    ],
  },
  // Additional instances for "matte sunscreen"
  "1-2-1": {
    id: "1-2-1",
    prioritySearchPhrase: "matte sunscreen",
    date: "Oct 10, 2025",
    totals: {
      relevantKeywords: 1580,
      exactVolume: 498700,
      monthlyUnits: 14200,
    },
    products: [
      { id: "p1", position: 1, isHero: true, brand: "Supergoop!", title: "Supergoop! Mineral Mattescreen (SPF 40)", asin: "B09JVX2NNR", imageUrl: "/placeholder.svg", reviews: 1250, rating: 4.5, price: 39.95, bsr: 6800, estMonthlyUnits: 6200, estMonthlyRevenue: 247690, capturedSearchVol: 68500, revVolRatio: 3.62, top15Positions: 305 },
      { id: "p2", position: 2, isHero: false, brand: "Blue Lizard", title: "Blue Lizard Mineral Sunscreen SPF 50+", asin: "B07T2VH5K9", imageUrl: "/placeholder.svg", reviews: 11500, rating: 4.7, price: 17.99, bsr: 460, estMonthlyUnits: 22800, estMonthlyRevenue: 410172, capturedSearchVol: 185000, revVolRatio: 2.22, top15Positions: 590 },
      { id: "p3", position: 3, isHero: false, brand: "Neutrogena", title: "Neutrogena Sheer Zinc Mineral Sunscreen", asin: "B01HOHBS7K", imageUrl: "/placeholder.svg", reviews: 8300, rating: 4.4, price: 12.97, bsr: 870, estMonthlyUnits: 18000, estMonthlyRevenue: 233460, capturedSearchVol: 148000, revVolRatio: 1.58, top15Positions: 468 },
      { id: "p4", position: 4, isHero: false, brand: "ThinkBaby", title: "ThinkBaby Safe Sunscreen SPF 50+", asin: "B004CDQ9EQ", imageUrl: "/placeholder.svg", reviews: 15000, rating: 4.6, price: 14.99, bsr: 600, estMonthlyUnits: 20800, estMonthlyRevenue: 311792, capturedSearchVol: 170000, revVolRatio: 1.83, top15Positions: 515 },
      { id: "p5", position: 5, isHero: false, brand: "Badger", title: "Badger Reef Safe Sunscreen SPF 40", asin: "B07NPFWC8H", imageUrl: "/placeholder.svg", reviews: 6400, rating: 4.3, price: 18.49, bsr: 1280, estMonthlyUnits: 13500, estMonthlyRevenue: 249615, capturedSearchVol: 92000, revVolRatio: 2.71, top15Positions: 335 },
      { id: "p6", position: 6, isHero: false, brand: "Sun Bum", title: "Sun Bum Mineral SPF 50 Sunscreen", asin: "B01LZKHXAS", imageUrl: "/placeholder.svg", reviews: 10600, rating: 4.5, price: 15.99, bsr: 740, estMonthlyUnits: 17500, estMonthlyRevenue: 279825, capturedSearchVol: 138000, revVolRatio: 2.03, top15Positions: 452 },
      { id: "p7", position: 7, isHero: false, brand: "Coppertone", title: "Coppertone Pure & Simple SPF 50", asin: "B07N8X5VDN", imageUrl: "/placeholder.svg", reviews: 4200, rating: 4.2, price: 11.47, bsr: 1620, estMonthlyUnits: 11500, estMonthlyRevenue: 131905, capturedSearchVol: 81000, revVolRatio: 1.63, top15Positions: 278 },
      { id: "p8", position: 8, isHero: false, brand: "Aveeno", title: "Aveeno Positively Mineral SPF 50", asin: "B07TQ8BZ9F", imageUrl: "/placeholder.svg", reviews: 7400, rating: 4.4, price: 13.97, bsr: 960, estMonthlyUnits: 15700, estMonthlyRevenue: 219329, capturedSearchVol: 106000, revVolRatio: 2.07, top15Positions: 395 },
      { id: "p9", position: 9, isHero: false, brand: "Australian Gold", title: "Australian Gold Botanical SPF 50", asin: "B074JZ9VG6", imageUrl: "/placeholder.svg", reviews: 9400, rating: 4.5, price: 14.47, bsr: 830, estMonthlyUnits: 16700, estMonthlyRevenue: 241649, capturedSearchVol: 128000, revVolRatio: 1.89, top15Positions: 425 },
      { id: "p10", position: 10, isHero: false, brand: "Alba Botanica", title: "Alba Botanica Hawaiian Sunscreen SPF 45", asin: "B000HGDXHC", imageUrl: "/placeholder.svg", reviews: 5100, rating: 4.3, price: 10.99, bsr: 2250, estMonthlyUnits: 9200, estMonthlyRevenue: 101108, capturedSearchVol: 63000, revVolRatio: 1.60, top15Positions: 220 },
    ],
    keywords: [
    ],
  },
  // Additional instances for "mineral sunscreen face"
  "1-3-2": {
    id: "1-3-2",
    prioritySearchPhrase: "mineral sunscreen face",
    date: "Oct 16, 2025",
    totals: {
      relevantKeywords: 1920,
      exactVolume: 720500,
      monthlyUnits: 19800,
    },
    products: [
      { id: "p1", position: 1, isHero: true, brand: "Supergoop!", title: "Supergoop! Mineral Mattescreen (SPF 40)", asin: "B09JVX2NNR", imageUrl: "/placeholder.svg", reviews: 1350, rating: 4.6, price: 39.95, bsr: 6600, estMonthlyUnits: 6400, estMonthlyRevenue: 255680, capturedSearchVol: 72800, revVolRatio: 3.51, top15Positions: 320 },
      { id: "p2", position: 2, isHero: false, brand: "Blue Lizard", title: "Blue Lizard Mineral Sunscreen SPF 50+", asin: "B07T2VH5K9", imageUrl: "/placeholder.svg", reviews: 12200, rating: 4.7, price: 17.99, bsr: 425, estMonthlyUnits: 24000, estMonthlyRevenue: 431760, capturedSearchVol: 195000, revVolRatio: 2.21, top15Positions: 608 },
      { id: "p3", position: 3, isHero: false, brand: "Neutrogena", title: "Neutrogena Sheer Zinc Mineral Sunscreen", asin: "B01HOHBS7K", imageUrl: "/placeholder.svg", reviews: 8800, rating: 4.4, price: 12.97, bsr: 850, estMonthlyUnits: 19000, estMonthlyRevenue: 246430, capturedSearchVol: 154000, revVolRatio: 1.60, top15Positions: 485 },
      { id: "p4", position: 4, isHero: false, brand: "ThinkBaby", title: "ThinkBaby Safe Sunscreen SPF 50+", asin: "B004CDQ9EQ", imageUrl: "/placeholder.svg", reviews: 15400, rating: 4.6, price: 14.99, bsr: 575, estMonthlyUnits: 21500, estMonthlyRevenue: 322285, capturedSearchVol: 176000, revVolRatio: 1.83, top15Positions: 530 },
      { id: "p5", position: 5, isHero: false, brand: "Badger", title: "Badger Reef Safe Sunscreen SPF 40", asin: "B07NPFWC8H", imageUrl: "/placeholder.svg", reviews: 6700, rating: 4.3, price: 18.49, bsr: 1250, estMonthlyUnits: 14200, estMonthlyRevenue: 262558, capturedSearchVol: 96000, revVolRatio: 2.73, top15Positions: 350 },
      { id: "p6", position: 6, isHero: false, brand: "Sun Bum", title: "Sun Bum Mineral SPF 50 Sunscreen", asin: "B01LZKHXAS", imageUrl: "/placeholder.svg", reviews: 11000, rating: 4.5, price: 15.99, bsr: 690, estMonthlyUnits: 18500, estMonthlyRevenue: 295815, capturedSearchVol: 142000, revVolRatio: 2.08, top15Positions: 470 },
      { id: "p7", position: 7, isHero: false, brand: "Coppertone", title: "Coppertone Pure & Simple SPF 50", asin: "B07N8X5VDN", imageUrl: "/placeholder.svg", reviews: 4450, rating: 4.2, price: 11.47, bsr: 1580, estMonthlyUnits: 12100, estMonthlyRevenue: 138787, capturedSearchVol: 85000, revVolRatio: 1.63, top15Positions: 292 },
      { id: "p8", position: 8, isHero: false, brand: "Aveeno", title: "Aveeno Positively Mineral SPF 50", asin: "B07TQ8BZ9F", imageUrl: "/placeholder.svg", reviews: 7700, rating: 4.4, price: 13.97, bsr: 940, estMonthlyUnits: 16300, estMonthlyRevenue: 227711, capturedSearchVol: 110000, revVolRatio: 2.07, top15Positions: 408 },
      { id: "p9", position: 9, isHero: false, brand: "Australian Gold", title: "Australian Gold Botanical SPF 50", asin: "B074JZ9VG6", imageUrl: "/placeholder.svg", reviews: 9700, rating: 4.5, price: 14.47, bsr: 800, estMonthlyUnits: 17500, estMonthlyRevenue: 253225, capturedSearchVol: 132000, revVolRatio: 1.92, top15Positions: 440 },
      { id: "p10", position: 10, isHero: false, brand: "Alba Botanica", title: "Alba Botanica Hawaiian Sunscreen SPF 45", asin: "B000HGDXHC", imageUrl: "/placeholder.svg", reviews: 5350, rating: 4.3, price: 10.99, bsr: 2150, estMonthlyUnits: 9600, estMonthlyRevenue: 105504, capturedSearchVol: 66000, revVolRatio: 1.60, top15Positions: 230 },
    ],
    keywords: [
    ],
  },
  "1-3-1": {
    id: "1-3-1",
    prioritySearchPhrase: "mineral sunscreen face",
    date: "Oct 13, 2025",
    totals: {
      relevantKeywords: 1840,
      exactVolume: 698000,
      monthlyUnits: 18900,
    },
    products: [
      { id: "p1", position: 1, isHero: true, brand: "Supergoop!", title: "Supergoop! Mineral Mattescreen (SPF 40)", asin: "B09JVX2NNR", imageUrl: "/placeholder.svg", reviews: 1300, rating: 4.5, price: 39.95, bsr: 6900, estMonthlyUnits: 6150, estMonthlyRevenue: 245693, capturedSearchVol: 70500, revVolRatio: 3.48, top15Positions: 312 },
      { id: "p2", position: 2, isHero: false, brand: "Blue Lizard", title: "Blue Lizard Mineral Sunscreen SPF 50+", asin: "B07T2VH5K9", imageUrl: "/placeholder.svg", reviews: 11900, rating: 4.7, price: 17.99, bsr: 440, estMonthlyUnits: 23500, estMonthlyRevenue: 422765, capturedSearchVol: 192000, revVolRatio: 2.20, top15Positions: 600 },
      { id: "p3", position: 3, isHero: false, brand: "Neutrogena", title: "Neutrogena Sheer Zinc Mineral Sunscreen", asin: "B01HOHBS7K", imageUrl: "/placeholder.svg", reviews: 8600, rating: 4.4, price: 12.97, bsr: 865, estMonthlyUnits: 18700, estMonthlyRevenue: 242539, capturedSearchVol: 152000, revVolRatio: 1.60, top15Positions: 480 },
      { id: "p4", position: 4, isHero: false, brand: "ThinkBaby", title: "ThinkBaby Safe Sunscreen SPF 50+", asin: "B004CDQ9EQ", imageUrl: "/placeholder.svg", reviews: 15300, rating: 4.6, price: 14.99, bsr: 580, estMonthlyUnits: 21200, estMonthlyRevenue: 317788, capturedSearchVol: 174000, revVolRatio: 1.83, top15Positions: 525 },
      { id: "p5", position: 5, isHero: false, brand: "Badger", title: "Badger Reef Safe Sunscreen SPF 40", asin: "B07NPFWC8H", imageUrl: "/placeholder.svg", reviews: 6600, rating: 4.3, price: 18.49, bsr: 1270, estMonthlyUnits: 14000, estMonthlyRevenue: 258860, capturedSearchVol: 95000, revVolRatio: 2.72, top15Positions: 345 },
      { id: "p6", position: 6, isHero: false, brand: "Sun Bum", title: "Sun Bum Mineral SPF 50 Sunscreen", asin: "B01LZKHXAS", imageUrl: "/placeholder.svg", reviews: 10900, rating: 4.5, price: 15.99, bsr: 700, estMonthlyUnits: 18200, estMonthlyRevenue: 291018, capturedSearchVol: 140000, revVolRatio: 2.08, top15Positions: 465 },
      { id: "p7", position: 7, isHero: false, brand: "Coppertone", title: "Coppertone Pure & Simple SPF 50", asin: "B07N8X5VDN", imageUrl: "/placeholder.svg", reviews: 4400, rating: 4.2, price: 11.47, bsr: 1600, estMonthlyUnits: 11900, estMonthlyRevenue: 136493, capturedSearchVol: 84000, revVolRatio: 1.62, top15Positions: 288 },
      { id: "p8", position: 8, isHero: false, brand: "Aveeno", title: "Aveeno Positively Mineral SPF 50", asin: "B07TQ8BZ9F", imageUrl: "/placeholder.svg", reviews: 7600, rating: 4.4, price: 13.97, bsr: 950, estMonthlyUnits: 16100, estMonthlyRevenue: 224917, capturedSearchVol: 109000, revVolRatio: 2.06, top15Positions: 405 },
      { id: "p9", position: 9, isHero: false, brand: "Australian Gold", title: "Australian Gold Botanical SPF 50", asin: "B074JZ9VG6", imageUrl: "/placeholder.svg", reviews: 9600, rating: 4.5, price: 14.47, bsr: 810, estMonthlyUnits: 17200, estMonthlyRevenue: 248884, capturedSearchVol: 131000, revVolRatio: 1.90, top15Positions: 435 },
      { id: "p10", position: 10, isHero: false, brand: "Alba Botanica", title: "Alba Botanica Hawaiian Sunscreen SPF 45", asin: "B000HGDXHC", imageUrl: "/placeholder.svg", reviews: 5300, rating: 4.3, price: 10.99, bsr: 2180, estMonthlyUnits: 9500, estMonthlyRevenue: 104405, capturedSearchVol: 65000, revVolRatio: 1.61, top15Positions: 228 },
    ],
    keywords: [
    ],
  },
};

// Helper to get landscape output data by instance ID
export function getLandscapeOutputById(instanceId: string): LandscapeOutputData | undefined {
  const direct = mockLandscapeOutputs[instanceId];
  if (direct) return direct;
  // For instances that share a landscape (e.g. "1-1-17" falls back to "1-1-3" data)
  // find any entry whose id prefix matches (same landscape, different version)
  const prefix = instanceId.replace(/-\d+$/, "");
  const fallback = Object.values(mockLandscapeOutputs).find((d) => d.id.startsWith(prefix));
  return fallback ? { ...fallback, id: instanceId } : undefined;
}

// Helper to get all instances for a priority search phrase
export function getInstancesByPhrase(phrase: string): LandscapeOutputData[] {
  return Object.values(mockLandscapeOutputs)
    .filter((data) => data.prioritySearchPhrase.toLowerCase() === phrase.toLowerCase())
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
}
